function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function (t) {
  var n = {};

  function e(i) {
    if (n[i]) return n[i].exports;
    var o = n[i] = {
      i: i,
      l: !1,
      exports: {}
    };
    return t[i].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
  }

  return e.m = t, e.c = n, e.d = function (t, n, i) {
    e.o(t, n) || Object.defineProperty(t, n, {
      enumerable: !0,
      get: i
    });
  }, e.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, e.t = function (t, n) {
    if (1 & n && (t = e(t)), 8 & n) return t;
    if (4 & n && "object" == _typeof(t) && t && t.__esModule) return t;
    var i = Object.create(null);
    if (e.r(i), Object.defineProperty(i, "default", {
      enumerable: !0,
      value: t
    }), 2 & n && "string" != typeof t) for (var o in t) {
      e.d(i, o, function (n) {
        return t[n];
      }.bind(null, o));
    }
    return i;
  }, e.n = function (t) {
    var n = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return e.d(n, "a", n), n;
  }, e.o = function (t, n) {
    return Object.prototype.hasOwnProperty.call(t, n);
  }, e.p = "", e(e.s = 1);
}([function (t, n, e) {
  var i, o;
  (function () {
    (function () {
      (function () {
        var t = [].slice;
        this.ActionCable = {
          INTERNAL: {
            message_types: {
              welcome: "welcome",
              ping: "ping",
              confirmation: "confirm_subscription",
              rejection: "reject_subscription"
            },
            default_mount_path: "/cable",
            protocols: ["actioncable-v1-json", "actioncable-unsupported"]
          },
          WebSocket: window.WebSocket,
          logger: window.console,
          createConsumer: function createConsumer(t) {
            var n;
            return null == t && (t = null != (n = this.getConfig("url")) ? n : this.INTERNAL.default_mount_path), new r.Consumer(this.createWebSocketURL(t));
          },
          getConfig: function getConfig(t) {
            var n;
            return null != (n = document.head.querySelector("meta[name='action-cable-" + t + "']")) ? n.getAttribute("content") : void 0;
          },
          createWebSocketURL: function createWebSocketURL(t) {
            var n;
            return t && !/^wss?:/i.test(t) ? ((n = document.createElement("a")).href = t, n.href = n.href, n.protocol = n.protocol.replace("http", "ws"), n.href) : t;
          },
          startDebugging: function startDebugging() {
            return this.debugging = !0;
          },
          stopDebugging: function stopDebugging() {
            return this.debugging = null;
          },
          log: function log() {
            var n, e;
            if (n = 1 <= arguments.length ? t.call(arguments, 0) : [], this.debugging) return n.push(Date.now()), (e = this.logger).log.apply(e, ["[ActionCable]"].concat(t.call(n)));
          }
        };
      }).call(this);
    }).call(this);
    var r = this.ActionCable;
    (function () {
      (function () {
        r.ConnectionMonitor = function () {
          var t, n, e;

          function i(t) {
            var n, e;
            this.connection = t, this.visibilityDidChange = (n = this.visibilityDidChange, e = this, function () {
              return n.apply(e, arguments);
            }), this.reconnectAttempts = 0;
          }

          return i.pollInterval = {
            min: 3,
            max: 30
          }, i.staleThreshold = 6, i.prototype.start = function () {
            if (!this.isRunning()) return this.startedAt = n(), delete this.stoppedAt, this.startPolling(), document.addEventListener("visibilitychange", this.visibilityDidChange), r.log("ConnectionMonitor started. pollInterval = " + this.getPollInterval() + " ms");
          }, i.prototype.stop = function () {
            if (this.isRunning()) return this.stoppedAt = n(), this.stopPolling(), document.removeEventListener("visibilitychange", this.visibilityDidChange), r.log("ConnectionMonitor stopped");
          }, i.prototype.isRunning = function () {
            return null != this.startedAt && null == this.stoppedAt;
          }, i.prototype.recordPing = function () {
            return this.pingedAt = n();
          }, i.prototype.recordConnect = function () {
            return this.reconnectAttempts = 0, this.recordPing(), delete this.disconnectedAt, r.log("ConnectionMonitor recorded connect");
          }, i.prototype.recordDisconnect = function () {
            return this.disconnectedAt = n(), r.log("ConnectionMonitor recorded disconnect");
          }, i.prototype.startPolling = function () {
            return this.stopPolling(), this.poll();
          }, i.prototype.stopPolling = function () {
            return clearTimeout(this.pollTimeout);
          }, i.prototype.poll = function () {
            return this.pollTimeout = setTimeout((t = this, function () {
              return t.reconnectIfStale(), t.poll();
            }), this.getPollInterval());
            var t;
          }, i.prototype.getPollInterval = function () {
            var n, e, i, o;
            return i = (o = this.constructor.pollInterval).min, e = o.max, n = 5 * Math.log(this.reconnectAttempts + 1), Math.round(1e3 * t(n, i, e));
          }, i.prototype.reconnectIfStale = function () {
            if (this.connectionIsStale()) return r.log("ConnectionMonitor detected stale connection. reconnectAttempts = " + this.reconnectAttempts + ", pollInterval = " + this.getPollInterval() + " ms, time disconnected = " + e(this.disconnectedAt) + " s, stale threshold = " + this.constructor.staleThreshold + " s"), this.reconnectAttempts++, this.disconnectedRecently() ? r.log("ConnectionMonitor skipping reopening recent disconnect") : (r.log("ConnectionMonitor reopening"), this.connection.reopen());
          }, i.prototype.connectionIsStale = function () {
            var t;
            return e(null != (t = this.pingedAt) ? t : this.startedAt) > this.constructor.staleThreshold;
          }, i.prototype.disconnectedRecently = function () {
            return this.disconnectedAt && e(this.disconnectedAt) < this.constructor.staleThreshold;
          }, i.prototype.visibilityDidChange = function () {
            if ("visible" === document.visibilityState) return setTimeout((t = this, function () {
              if (t.connectionIsStale() || !t.connection.isOpen()) return r.log("ConnectionMonitor reopening stale connection on visibilitychange. visbilityState = " + document.visibilityState), t.connection.reopen();
            }), 200);
            var t;
          }, n = function n() {
            return new Date().getTime();
          }, e = function e(t) {
            return (n() - t) / 1e3;
          }, t = function t(_t, n, e) {
            return Math.max(n, Math.min(e, _t));
          }, i;
        }();
      }).call(this), function () {
        var t,
            n,
            e,
            i,
            o,
            c = [].slice,
            s = [].indexOf || function (t) {
          for (var n = 0, e = this.length; n < e; n++) {
            if (n in this && this[n] === t) return n;
          }

          return -1;
        };

        i = r.INTERNAL, n = i.message_types, e = i.protocols, o = 2 <= e.length ? c.call(e, 0, t = e.length - 1) : (t = 0, []), e[t++], r.Connection = function () {
          function t(t) {
            var n, e;
            this.consumer = t, this.open = (n = this.open, e = this, function () {
              return n.apply(e, arguments);
            }), this.subscriptions = this.consumer.subscriptions, this.monitor = new r.ConnectionMonitor(this), this.disconnected = !0;
          }

          return t.reopenDelay = 500, t.prototype.send = function (t) {
            return !!this.isOpen() && (this.webSocket.send(JSON.stringify(t)), !0);
          }, t.prototype.open = function () {
            return this.isActive() ? (r.log("Attempted to open WebSocket, but existing socket is " + this.getState()), !1) : (r.log("Opening WebSocket, current state is " + this.getState() + ", subprotocols: " + e), null != this.webSocket && this.uninstallEventHandlers(), this.webSocket = new r.WebSocket(this.consumer.url, e), this.installEventHandlers(), this.monitor.start(), !0);
          }, t.prototype.close = function (t) {
            var n;
            if ((null != t ? t : {
              allowReconnect: !0
            }).allowReconnect || this.monitor.stop(), this.isActive()) return null != (n = this.webSocket) ? n.close() : void 0;
          }, t.prototype.reopen = function () {
            var t;
            if (r.log("Reopening WebSocket, current state is " + this.getState()), !this.isActive()) return this.open();

            try {
              return this.close();
            } catch (n) {
              return t = n, r.log("Failed to reopen WebSocket", t);
            } finally {
              r.log("Reopening WebSocket in " + this.constructor.reopenDelay + "ms"), setTimeout(this.open, this.constructor.reopenDelay);
            }
          }, t.prototype.getProtocol = function () {
            var t;
            return null != (t = this.webSocket) ? t.protocol : void 0;
          }, t.prototype.isOpen = function () {
            return this.isState("open");
          }, t.prototype.isActive = function () {
            return this.isState("open", "connecting");
          }, t.prototype.isProtocolSupported = function () {
            var t;
            return t = this.getProtocol(), s.call(o, t) >= 0;
          }, t.prototype.isState = function () {
            var t, n;
            return n = 1 <= arguments.length ? c.call(arguments, 0) : [], t = this.getState(), s.call(n, t) >= 0;
          }, t.prototype.getState = function () {
            var t, n;

            for (n in WebSocket) {
              if (WebSocket[n] === (null != (t = this.webSocket) ? t.readyState : void 0)) return n.toLowerCase();
            }

            return null;
          }, t.prototype.installEventHandlers = function () {
            var t, n;

            for (t in this.events) {
              n = this.events[t].bind(this), this.webSocket["on" + t] = n;
            }
          }, t.prototype.uninstallEventHandlers = function () {
            var t;

            for (t in this.events) {
              this.webSocket["on" + t] = function () {};
            }
          }, t.prototype.events = {
            message: function message(t) {
              var e, i, o;
              if (this.isProtocolSupported()) switch (e = (o = JSON.parse(t.data)).identifier, i = o.message, o.type) {
                case n.welcome:
                  return this.monitor.recordConnect(), this.subscriptions.reload();

                case n.ping:
                  return this.monitor.recordPing();

                case n.confirmation:
                  return this.subscriptions.notify(e, "connected");

                case n.rejection:
                  return this.subscriptions.reject(e);

                default:
                  return this.subscriptions.notify(e, "received", i);
              }
            },
            open: function open() {
              if (r.log("WebSocket onopen event, using '" + this.getProtocol() + "' subprotocol"), this.disconnected = !1, !this.isProtocolSupported()) return r.log("Protocol is unsupported. Stopping monitor and disconnecting."), this.close({
                allowReconnect: !1
              });
            },
            close: function close(t) {
              if (r.log("WebSocket onclose event"), !this.disconnected) return this.disconnected = !0, this.monitor.recordDisconnect(), this.subscriptions.notifyAll("disconnected", {
                willAttemptReconnect: this.monitor.isRunning()
              });
            },
            error: function error() {
              return r.log("WebSocket onerror event");
            }
          }, t;
        }();
      }.call(this), function () {
        var t = [].slice;

        r.Subscriptions = function () {
          function n(t) {
            this.consumer = t, this.subscriptions = [];
          }

          return n.prototype.create = function (t, n) {
            var e, i, o;
            return i = "object" == _typeof(e = t) ? e : {
              channel: e
            }, o = new r.Subscription(this.consumer, i, n), this.add(o);
          }, n.prototype.add = function (t) {
            return this.subscriptions.push(t), this.consumer.ensureActiveConnection(), this.notify(t, "initialized"), this.sendCommand(t, "subscribe"), t;
          }, n.prototype.remove = function (t) {
            return this.forget(t), this.findAll(t.identifier).length || this.sendCommand(t, "unsubscribe"), t;
          }, n.prototype.reject = function (t) {
            var n, e, i, o, r;

            for (o = [], n = 0, e = (i = this.findAll(t)).length; n < e; n++) {
              r = i[n], this.forget(r), this.notify(r, "rejected"), o.push(r);
            }

            return o;
          }, n.prototype.forget = function (t) {
            var n;
            return this.subscriptions = function () {
              var e, i, o, r;

              for (r = [], e = 0, i = (o = this.subscriptions).length; e < i; e++) {
                (n = o[e]) !== t && r.push(n);
              }

              return r;
            }.call(this), t;
          }, n.prototype.findAll = function (t) {
            var n, e, i, o, r;

            for (o = [], n = 0, e = (i = this.subscriptions).length; n < e; n++) {
              (r = i[n]).identifier === t && o.push(r);
            }

            return o;
          }, n.prototype.reload = function () {
            var t, n, e, i, o;

            for (i = [], t = 0, n = (e = this.subscriptions).length; t < n; t++) {
              o = e[t], i.push(this.sendCommand(o, "subscribe"));
            }

            return i;
          }, n.prototype.notifyAll = function () {
            var n, e, i, o, r, c, s;

            for (e = arguments[0], n = 2 <= arguments.length ? t.call(arguments, 1) : [], c = [], i = 0, o = (r = this.subscriptions).length; i < o; i++) {
              s = r[i], c.push(this.notify.apply(this, [s, e].concat(t.call(n))));
            }

            return c;
          }, n.prototype.notify = function () {
            var n, e, i, o, r, c, s;

            for (c = arguments[0], e = arguments[1], n = 3 <= arguments.length ? t.call(arguments, 2) : [], r = [], i = 0, o = (s = "string" == typeof c ? this.findAll(c) : [c]).length; i < o; i++) {
              c = s[i], r.push("function" == typeof c[e] ? c[e].apply(c, n) : void 0);
            }

            return r;
          }, n.prototype.sendCommand = function (t, n) {
            var e;
            return e = t.identifier, this.consumer.send({
              command: n,
              identifier: e
            });
          }, n;
        }();
      }.call(this), function () {
        r.Subscription = function () {
          var t;

          function n(n, e, i) {
            this.consumer = n, null == e && (e = {}), this.identifier = JSON.stringify(e), t(this, i);
          }

          return n.prototype.perform = function (t, n) {
            return null == n && (n = {}), n.action = t, this.send(n);
          }, n.prototype.send = function (t) {
            return this.consumer.send({
              command: "message",
              identifier: this.identifier,
              data: JSON.stringify(t)
            });
          }, n.prototype.unsubscribe = function () {
            return this.consumer.subscriptions.remove(this);
          }, t = function t(_t2, n) {
            var e, i;
            if (null != n) for (e in n) {
              i = n[e], _t2[e] = i;
            }
            return _t2;
          }, n;
        }();
      }.call(this), function () {
        r.Consumer = function () {
          function t(t) {
            this.url = t, this.subscriptions = new r.Subscriptions(this), this.connection = new r.Connection(this);
          }

          return t.prototype.send = function (t) {
            return this.connection.send(t);
          }, t.prototype.connect = function () {
            return this.connection.open();
          }, t.prototype.disconnect = function () {
            return this.connection.close({
              allowReconnect: !1
            });
          }, t.prototype.ensureActiveConnection = function () {
            if (!this.connection.isActive()) return this.connection.open();
          }, t;
        }();
      }.call(this);
    }).call(this), t.exports ? t.exports = r : void 0 === (o = "function" == typeof (i = r) ? i.call(n, e, n, t) : i) || (t.exports = o);
  }).call(this);
}, function (t, n, e) {
  "use strict";

  function i(t, n) {
    var e;

    if ("undefined" == typeof Symbol || null == t[Symbol.iterator]) {
      if (Array.isArray(t) || (e = function (t, n) {
        if (!t) return;
        if ("string" == typeof t) return o(t, n);
        var e = Object.prototype.toString.call(t).slice(8, -1);
        "Object" === e && t.constructor && (e = t.constructor.name);
        if ("Map" === e || "Set" === e) return Array.from(t);
        if ("Arguments" === e || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return o(t, n);
      }(t)) || n && t && "number" == typeof t.length) {
        e && (t = e);

        var i = 0,
            r = function r() {};

        return {
          s: r,
          n: function n() {
            return i >= t.length ? {
              done: !0
            } : {
              done: !1,
              value: t[i++]
            };
          },
          e: function e(t) {
            throw t;
          },
          f: r
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var c,
        s = !0,
        a = !1;
    return {
      s: function s() {
        e = t[Symbol.iterator]();
      },
      n: function n() {
        var t = e.next();
        return s = t.done, t;
      },
      e: function e(t) {
        a = !0, c = t;
      },
      f: function f() {
        try {
          s || null == e.return || e.return();
        } finally {
          if (a) throw c;
        }
      }
    };
  }

  function o(t, n) {
    (null == n || n > t.length) && (n = t.length);

    for (var e = 0, i = new Array(n); e < n; e++) {
      i[e] = t[e];
    }

    return i;
  }

  function r(t) {
    return (r = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
      return _typeof(t);
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
    })(t);
  }

  function c(t, n) {
    var e = Object.keys(t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(t);
      n && (i = i.filter(function (n) {
        return Object.getOwnPropertyDescriptor(t, n).enumerable;
      })), e.push.apply(e, i);
    }

    return e;
  }

  function s(t) {
    for (var n = 1; n < arguments.length; n++) {
      var e = null != arguments[n] ? arguments[n] : {};
      n % 2 ? c(Object(e), !0).forEach(function (n) {
        a(t, n, e[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : c(Object(e)).forEach(function (n) {
        Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(e, n));
      });
    }

    return t;
  }

  function a(t, n, e) {
    return n in t ? Object.defineProperty(t, n, {
      value: e,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[n] = e, t;
  }

  function u(t, n) {
    if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
  }

  function l(t, n) {
    for (var e = 0; e < n.length; e++) {
      var i = n[e];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }

  e.r(n);

  var h = function () {
    function t(n, e, i) {
      var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
      if (u(this, t), void 0 === n) throw new Error("CableCar: unknown ActionCable provider: ".concat(n));
      if (void 0 === e || void 0 === e.dispatch) throw new Error("CableCar: unknown store: ".concat(e));
      if ("string" != typeof i) throw new Error("CableCar: unknown channel: ".concat(i));
      this.actionCableProvider = n, this.store = e;
      var r = {
        prefix: "RAILS",
        optimisticOnFail: !1
      };
      this.initialize(i, s(s({}, r), o));
    }

    var n, e, o;
    return n = t, (e = [{
      key: "initialize",
      value: function value(t, n) {
        var e = this;
        this.channel = t, this.options = n, this.running = !1;
        var i = n.params || {};
        i = s({
          channel: t
        }, i), this.initialized = function () {
          return e.dispatch({
            type: "CABLECAR_INITIALIZED"
          });
        }, this.connected = function () {
          e.running = !0, e.dispatch({
            type: "CABLECAR_CONNECTED"
          }), e.options.connected && e.options.connected.call();
        }, this.disconnected = function () {
          e.running = !1, e.dispatch({
            type: "CABLECAR_DISCONNECTED"
          }), e.options.disconnected && e.options.disconnected.call();
        }, this.received = function (t) {
          e.dispatch(t);
        }, this.rejected = function () {
          throw new Error("CableCar: Attempt to connect was rejected.\n        (Channel: ".concat(e.channel, ")"));
        }, this.subscription = this.actionCableProvider.createConsumer(n.wsURL).subscriptions.create(i, {
          initialized: this.initialized,
          connected: this.connected,
          disconnected: this.disconnected,
          received: this.received,
          rejected: this.rejected
        });
      }
    }, {
      key: "dispatch",
      value: function value(t) {
        var n = s(s({}, t), {}, {
          channel: this.channel,
          CableCar__Action: !0
        });
        this.store.dispatch(n);
      }
    }, {
      key: "allows",
      value: function value(t) {
        if ("object" !== r(t) || "string" != typeof t.type) throw new Error("CableCar: ".concat(t, " is not a valid redux action ({ type: ... })"));
        return this.matchPrefix(t.type);
      }
    }, {
      key: "matchPrefix",
      value: function value(t) {
        var n,
            e = !1,
            o = i([].concat(this.options.prefix));

        try {
          for (o.s(); !(n = o.n()).done;) {
            var r = n.value;

            if (t.slice(0, String(r).length) === String(r)) {
              e = !0;
              break;
            }
          }
        } catch (t) {
          o.e(t);
        } finally {
          o.f();
        }

        return e;
      }
    }, {
      key: "changeChannel",
      value: function value(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        this.unsubscribe(), this.initialize(t, s(s({}, this.options), n));
      }
    }, {
      key: "getChannel",
      value: function value() {
        return this.channel;
      }
    }, {
      key: "getParams",
      value: function value() {
        return this.options.params;
      }
    }, {
      key: "perform",
      value: function value(t, n) {
        this.subscription.perform(t, n);
      }
    }, {
      key: "send",
      value: function value(t) {
        this.subscription.send(t);
      }
    }, {
      key: "unsubscribe",
      value: function value() {
        this.subscription.unsubscribe(), this.disconnected();
      }
    }]) && l(n.prototype, e), o && l(n, o), t;
  }();

  function p(t, n) {
    for (var e = 0; e < n.length; e++) {
      var i = n[e];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }

  var f,
      d = new (function () {
    function t(n) {
      !function (t, n) {
        if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, t);
      var e = {};
      this.addLine = function (t, n) {
        e[t] = n;
      }, this.clearAllLines = function () {
        e = {};
      }, this.clearLine = function (t) {
        e[t] = void 0;
      }, this.getLines = function () {
        return e;
      };
    }

    var n, e, i;
    return n = t, (e = [{
      key: "addCar",
      value: function value(t, n) {
        if (this.getCar(t)) throw new ReferenceError("CableCar Dispatcher: cannot connect two cars to same line/channel: " + t);
        return this.addLine(t, n), n;
      }
    }, {
      key: "changeCar",
      value: function value(t, n, e) {
        var i = this.getCar(t);
        return i ? i.changeChannel ? (i.changeChannel(n, e), this.clearLine(t), this.addLine(n, i), i) : (console.error(new ReferenceError("CableCar Dispatcher (change failed): car has no changeChannel function"), i), !1) : (console.error(new ReferenceError("CableCar Dispatcher (change failed): no car found on line/channel: " + t)), !1);
      }
    }, {
      key: "destroyCar",
      value: function value(t) {
        var n = t || this.getSingleActiveLine();
        if (!n) return console.error(new ReferenceError("CableCar Dispatcher (destroy failed): No car found on line/channel: " + t)), !1;
        var e = this.getCar(n);
        return e && e.unsubscribe ? (e.unsubscribe(), this.clearLine(n), e) : (console.error(new ReferenceError("CableCar Dispatcher (destroy failed): car has no unsubscribe function"), e), !1);
      }
    }, {
      key: "getCar",
      value: function value(t) {
        return this.getLines()[t];
      }
    }, {
      key: "getDefaultCar",
      value: function value() {
        var t = this.getSingleActiveLine();
        return t ? this.getLines()[t] : void 0;
      }
    }, {
      key: "getSingleActiveLine",
      value: function value() {
        var t = this.getLines(),
            n = [];

        for (var e in t) {
          t[e] && n.push(e);
        }

        return 1 === n.length ? n[0] : void 0;
      }
    }, {
      key: "reset",
      value: function value() {
        this.clearAllLines();
      }
    }]) && p(n.prototype, e), i && p(n, i), t;
  }())(),
      g = function g(t) {
    return function (n) {
      return function (e) {
        var i,
            o = e;

        switch (o.type) {
          case "CABLECAR_INITIALIZED":
          case "CABLECAR_CONNECTED":
          case "CABLECAR_DISCONNECTED":
            return n(o);

          case "CABLECAR_DESTROY":
            return d.destroyCar(o.CableCarChannel), t.getState();

          case "CABLECAR_DESTROY_ALL":
            return d.reset(), t.getState();

          case "CABLECAR_CHANGE_CHANNEL":
            return d.changeCar(o.previousChannel, o.newChannel, o.options), t.getState();

          default:
            return (i = o.channel ? d.getCar(o.channel) : d.getDefaultCar()) && i.allows(o) && !o.CableCar__Action ? i.running ? (i.send(o), o.optimistic ? n(o) : t.getState()) : (console.error("CableCar: Dropped action!", "Attempting to dispatch an action but cable car is not running.", o, "optimisticOnFail: " + i.options.optimisticOnFail), i.options.optimisticOnFail ? n(o) : t.getState()) : n(o);
        }
      };
    };
  };

  g.connect = function (t, n, i) {
    if (!f) try {
      f = e(0);
    } catch (t) {
      throw new Error("CableCar: No actionCableProvider set and 'actioncable' Node package failed to load: ".concat(t));
    }
    var o = new h(f, t, n, i);
    return d.addCar(n, o), {
      changeChannel: o.changeChannel.bind(o),
      getChannel: o.getChannel.bind(o),
      getParams: o.getParams.bind(o),
      perform: o.perform.bind(o),
      send: o.send.bind(o),
      unsubscribe: o.unsubscribe.bind(o)
    };
  }, g.setProvider = function (t) {
    f = t;
  };
  var b = g;
  n.default = b;
}]);